import React from 'react'

import { SxProps } from '@mui/material'

import { useMetricCategories } from 'redux/hooks/Categories'

import ChipTabs from 'components_new/molecules/ChipTabs'
import { useTranslation } from 'language/translator'
import { sortAlphabeticalAsc } from 'utils/sortHelper'

interface Props {
  sx?: SxProps
  category: string | null
  subcategory: string | null
  setSubcategory: (subcategory: string | null) => void
}

const MetricsFilter = (props: Props) => {
  const { sx, category, subcategory, setSubcategory } = props
  const categories = useMetricCategories()
  const { lang } = useTranslation()

  const getOptions = () => {
    if (!category || !categories[category]) return []

    return categories[category].subcategories
      .map((sc) => {
        return {
          label: sc.title[lang],
          value: sc.slug
        }
      })
      .sort((a, b) => sortAlphabeticalAsc(a.label, b.label))
  }

  return (
    <ChipTabs
      onChange={setSubcategory}
      options={getOptions()}
      size="small"
      value={subcategory}
      sx={sx}
    />
  )
}

export default MetricsFilter
